import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Badge from '../../../../components/global/Badge';
import { AlbumMembershipGroupTaggedPhotosModal } from '../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/components/AlbumMembershipGroupTaggedPhotos';
import { getAlbumPrintPackageTaggedItem } from '../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/helpers';

const propTypes = {
  className: PropTypes.string,
  albumPrintPackageCartItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    albumPrintPackage: PropTypes.shape({
      id: PropTypes.string.isRequired,
      print_package: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  onCartItemUpdate: PropTypes.func.isRequired,
};

const AlbumPrintPackageCartItemTaggedPhotoUpsell = ({
  className,
  albumPrintPackageCartItem,
  onCartItemUpdate,
}) => {
  const classes = classNames({
    'checkout-album-print-package-cart-item-tagged-photo-upsell': true,
    [className]: !!className,
  });

  const [openTaggedPhotoModal, setOpenTaggedPhotosModal] = useState(false);

  const { albumPrintPackage } = albumPrintPackageCartItem;
  const overriddenPrintPackageItem = getAlbumPrintPackageTaggedItem(
    albumPrintPackage,
  );
  const albumFolderTag = overriddenPrintPackageItem.album_folder_tag;
  const price = overriddenPrintPackageItem.price?.value ?? 0;
  const discountPrice = overriddenPrintPackageItem.discount_price?.value ?? 0;
  const hasDiscount = !!discountPrice && discountPrice < price;
  const discountPercentage = (((price - discountPrice) / price) * 100).toFixed(
    2,
  );

  return (
    <Fragment>
      <a
        href="#"
        onClick={event => {
          event.preventDefault();
          setOpenTaggedPhotosModal(true);
        }}
        className={classes}
      >
        {hasDiscount && (
          <Badge
            className="purchasing-option-item-info-extra-tag"
            badgeSize="sm"
            badgeStyle="purple"
          >
            {albumFolderTag.name}{' '}
            <strong className="text-black ml-1">Promo</strong>
          </Badge>
        )}

        <div className="d-flex align-items-center w-100">
          <span className="d-block mr-1">
            {hasDiscount ? (
              <Fragment>
                Save {discountPercentage}% off your {albumFolderTag.name} print!
              </Fragment>
            ) : (
              <Fragment>
                Add a {albumFolderTag.name} to your Photo Package!
              </Fragment>
            )}
          </span>

          <span className="d-block text-bold ml-auto text-primary">&rarr;</span>
        </div>
      </a>

      <AlbumMembershipGroupTaggedPhotosModal
        forceOpen={openTaggedPhotoModal}
        onClose={() => {
          setOpenTaggedPhotosModal(false);
        }}
        cartItem={albumPrintPackageCartItem}
        overriddenPrintPackageItem={overriddenPrintPackageItem}
        photoIsOptional={overriddenPrintPackageItem?.is_optional && price > 0}
        albumFolderTag={albumFolderTag}
        albumMembershipGroupId={albumPrintPackage?.album_folder?.id}
        onPhotoSelect={({ photo, accountCard }) => {
          onCartItemUpdate(albumPrintPackageCartItem.id, {
            extendedPrintPackageItems: [
              {
                photo,
                printPackageItem: overriddenPrintPackageItem,
                accountCard,
              },
            ],
          });
        }}
      />
    </Fragment>
  );
};

AlbumPrintPackageCartItemTaggedPhotoUpsell.propTypes = propTypes;

export default AlbumPrintPackageCartItemTaggedPhotoUpsell;
